import { ViewModel,View, ObservableArray, ComponentTagMappings } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, ListPropertyType, StringPropertyType, TemplateSelectorPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { ColumnViewModel, ServerSideDataLoader } from "uicomponents";
import { ClientFileteringTableColumnsPropertyType } from "./clientFilterTable-viewModel";
import  { ServerFilteringTableView } from "./serverFilteringTable-view"

export class ServerFilterTableComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'ServerFilterTable';
        this.addProperty("Columns","",new ClientFileteringTableColumnsPropertyType(this),null,false);
        this.addProperty("ItemsSource","data-b-comp-showingitems",new ListPropertyType(this),null,false);
        this.addProperty("ItemTemplateSelector","data-b-comp-templateselectorfunction",new TemplateSelectorPropertyType(this),"",false);
        this.addProperty("Loader","data-b-comp-dataloader",new StringPropertyType(this),null,false);
        this.addProperty("UseElastics","data-b-comp-enableelasticsearch",new BooleanPropertyType(this),null,false);
        this.addProperty("StickyHeaders","data-b-comp-stickyheader",new BooleanPropertyType(this),false,false);
        
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ServerFilteringTableViewModel(parent);
        return result;
    }
    protected getClassDefaultValue(){
        return "exTable";
    }
}


export class ServerFilteringTableViewModel extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.ShowingColumns = ObservableArray.create<ColumnViewModel>();

    }
    GetDefaultView(): View <ViewModel> {
        return new ServerFilteringTableView();
    }
    public getTypeId(): string {
        return "VM-6A10EDCF-3109-4F38-A48B-CEABDA172E54"
    }

    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;
    public set UseElastics(v: boolean) { this._UseElastics = getAsBoolean(v); } public get UseElastics(): boolean { return this._UseElastics;} private _UseElastics: boolean;
    public set Loader(v: ServerSideDataLoader) { this._Loader = v; } public get Loader(): ServerSideDataLoader { return this._Loader;} private _Loader: ServerSideDataLoader;
    
    public set Columns(v: any) { 
        this._Columns = v; 
        this.updateColumns();
    } public get Columns(): any { return this._Columns;} private _Columns: any;
    public set ShowingColumns(v: ObservableArray<ColumnViewModel>) { this._ShowingColumns = v; } public get ShowingColumns(): ObservableArray<ColumnViewModel> { return this._ShowingColumns;} private _ShowingColumns: ObservableArray<ColumnViewModel>;
    public set ParentTableViewModel(v: ViewModel) { this._ParentTableViewModel = v; } public get ParentTableViewModel(): ViewModel { return this._ParentTableViewModel;} private _ParentTableViewModel: ViewModel;
    public set StickyHeaders(v: boolean) { this._StickyHeaders =getAsBoolean(v); } public get StickyHeaders(): boolean { return this._StickyHeaders;} private _StickyHeaders: boolean;
    
    updateColumns(){
        this.ShowingColumns.clear();
        if(stringIsNullOrEmpty(this.Columns)){
            return;
        }
        let columns = JSON.parse(this.Columns).map(x=>{
            let component = <ColumnViewModel><any>(ComponentTagMappings.getComponent(x.type)(this));
            component.fieldname = x.fieldname;
            component.name = x.title;
            return component;
        });
        this.ShowingColumns.update(...columns);
    }

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitServerFilterTable(this,parameter);
    }

    override onDataContextSet(){
        this.TemplateSelector = this.DataContext._Builder_TemplateSelector__;
    }
}
